export default function Reset() {

  localStorage.clear();

  return <>
    <div>
    </div>
  </>
}
